const Kitchens = () => import("./views/Kitchens.vue");
const KitchenEdit = () => import("./views/KitchenEdit.vue");

const route = "/kitchens";

export default [
  {
    path: route,
    name: "kitchens.list",
    component: Kitchens,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "kitchens.create",
    component: KitchenEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:kitchenId/edit`,
    name: "kitchens.edit",
    component: KitchenEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
